import { DE_PSEUDO_CARE_PROVIDER_REQUEST, dePseudoCareProviderFailure, dePseudoCareProviderSuccess } from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from, EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export function dePseudoCareProviderEpic(action$, store$, { CareProviderRepository }) {
    return action$.pipe(
        ofType(DE_PSEUDO_CARE_PROVIDER_REQUEST),
        mergeMap( action =>{
            const { id, pseudonym } = action.payload;

            if(!`${id}`.trim()) {
                return EMPTY;
            }

            return from(
                CareProviderRepository.dePseudoCareProvider( id )
                    .then(careProvider => dePseudoCareProviderSuccess(careProvider, pseudonym))
                    .catch(error => dePseudoCareProviderFailure(error)),
            );
        }),
    );
}
